import { createUseTranslation } from "core/session/translation";

export const useInternalLinkFieldTranslation = createUseTranslation({
  en: {
    configErrorTitle: "Config error",
    linkNotSet: "Link To is required",
    pageNotFound: "Page not found",
  },
});
